import Vue from 'vue'
import VueRouter from 'vue-router'
import ViewUI from 'view-design'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Main',
    component: () => import('@/components/Main.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页看板', icon: 'md-speedometer' }
      },
      {
        path: '/booking',
        name: 'Booking',
        component: () => import('@/views/booking/index.vue'),
        meta: { title: '预约看板', icon: 'md-calendar' }
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单管理', icon: 'md-list-box' }
      },
      {
        path: '/device',
        name: 'Device',
        component: () => import('@/views/device/index.vue'),
        meta: { title: '设备管理', icon: 'md-desktop' }
      },
      {
        path: '/staff',
        name: 'Staff',
        component: () => import('@/views/staff/index.vue'),
        meta: { title: '员工管理', icon: 'md-people' }
      },
      {
        path: '/store',
        name: 'Store',
        component: () => import('@/views/store/index.vue'),
        meta: { title: '店面管理', icon: 'md-home', roles: [0] }
      },
      {
        path: '/skin',
        name: 'Skin',
        component: () => import('@/views/skin/index.vue'),
        meta: { title: '翼装皮肤', icon: 'md-shirt', roles: [0] }
      },
      {
        path: '/ue',
        name: 'Ue',
        component: () => import('@/views/ue/index.vue'),
        meta: { title: 'UE 版本', icon: 'md-cube', roles: [0] }
      },
      {
        path: '/system',
        name: 'System',
        component: () => import('@/views/system/index.vue'),
        meta: { title: '系统配置', icon: 'md-settings', roles: [0, 1] }
      },
      {
        path: '/hours',
        name: 'Hours',
        component: () => import('@/views/hours/index.vue'),
        meta: { title: '运营时段', icon: 'md-time', roles: [0, 1] }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.public) {
    next()
  } else {
    const token = store.state.token
    if (token) {
      // 检查角色权限
      const userRole = store.state.userInfo.role
      const allowedRoles = to.meta.roles
      if (allowedRoles && !allowedRoles.includes(userRole)) {
        next('/dashboard')
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

router.afterEach(() => {
  // ViewUI.LoadingBar.finish()
})

export default router
